export const plugins = [{
    plugin: require('bernie-plugin-apollo/dist/browser')
  }]